// Video desktop/mobile (serve ovunque)
if ($(window).width() < 767) {
  $('.ps-desktop-video').hide();
  $('.ps-mobile-video').show();
} else {
  $('.ps-desktop-video').show();
  $('.ps-mobile-video').hide();
}
$(window).on('resize', function () {
  if ($(window).width() < 767) {
    $('.ps-desktop-video').hide();
    $('.ps-mobile-video').show();
  } else {
    $('.ps-desktop-video').show();
    $('.ps-mobile-video').hide();
  }
});

// Dropdown
function myFunction() {
  document.getElementById('myDropdown').classList.toggle('show');
}
window.onclick = function (event) {
  if (!event.target.matches('.dropbtn')) {
    var dropdowns = document.getElementsByClassName('dropdown-content');
    for (var i = 0; i < dropdowns.length; i++) {
      var openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }
};

// Accordion (solo se esiste)
if ($('.head').length) {
  $('.head').click(function () {
    $(this).toggleClass('active');
    $(this).parent().find('.arrow').toggleClass('arrow-animate');
    $(this).parent().find('.content').slideToggle(280);
  });
}

// Tabs (solo se esistono)
if ($('ul.tabs li').length) {
  $('ul.tabs li').click(function () {
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $('#' + tab_id).addClass('current');
  });
}

// Slick sliders (solo se esistono elementi slider nella pagina)
if ($('.image-slider').length || $('.review-slider').length || $('.mobileSlider').length) {
  if ($('.image-slider').length) {
    $('.image-slider').slick({
      dots: false,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 2,
      arrows: true,
      adaptiveHeight: true,
      prevArrow: '<button class="slide-arrow prev-arrow ps-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/left-arrow.png?v=1645678822"></button>',
      nextArrow: '<button class="slide-arrow next-arrow ps-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/right-arrow.png?v=1645678809"></button>',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true } },
        { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, dots: false } }
      ]
    });
  }

  if ($('.review-slider').length) {
    $('.review-slider').slick({
      dots: true,
      dotsClass: 'slide-dots',
      infinite: true,
      speed: 1500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      prevArrow: '<button class="slide-arrow prev-arrow ps-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/left-arrow.png?v=1645678822"></button>',
      nextArrow: '<button class="slide-arrow next-arrow ps-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/right-arrow.png?v=1645678809"></button>',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true } },
        { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }

  if ($('.mobileSlider').length) {
    $('.mobileSlider').slick({
      dots: false,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: '<button class="slide-arrow prev-arrow ps-arrow-left"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/left-arrow.png?v=1645678822"></button>',
      nextArrow: '<button class="slide-arrow next-arrow ps-arrow-right"><img src="https://cdn.shopify.com/s/files/1/0623/2703/0015/files/right-arrow.png?v=1645678809"></button>',
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
      ]
    });
  }
}

// Upsell/quantità prodotto (solo su pagine prodotto)
if ($('.allVariant').length) {
  $('.product-form__input .select__select').change(function () {
    setTimeout(function () {
      var getcurrvariantid = $('.getvariantid').val();
      var qty = $('.quantity__input').val();
      $('.allVariant option').each(function () {
        var thisvarif = $(this).val();
        if (thisvarif == getcurrvariantid) {
          var thisPrice = $(this).attr('data-price');
          thisPrice = (thisPrice * qty) / 100;
          var add_price = 0;
          $('.additionUpsell').each(function () {
            var pro_id = $(this).attr('data-id');
            var text = $('#getVaraint-' + pro_id + ' option:selected').text();
            if (text != 0) {
              $('.prop-' + pro_id).val(text);
              var price = $('#getVaraint-' + pro_id + ' option:selected').attr('data-price');
              add_price += parseFloat(price / 100);
            } else {
              $('.prop-' + pro_id).val('');
            }
          });
          setTimeout(function () {
            thisPrice = (thisPrice + add_price).toFixed(2).replace('.', ',');
            $('.totalPrice').text('Totale : ' + thisPrice + ' €');
          }, 500);
        }
      });
    }, 500);
  });

  $('.quantity__button').click(function () {
    setTimeout(function () {
      var getcurrvariantid = $('.getvariantid').val();
      var qty = $('.quantity__input').val();
      $('.allVariant option').each(function () {
        var thisvarif = $(this).val();
        if (thisvarif == getcurrvariantid) {
          var thisPrice = $(this).attr('data-price');
          thisPrice = (thisPrice * qty) / 100;
          var add_price = 0;
          $('.additionUpsell').each(function () {
            var pro_id = $(this).attr('data-id');
            var text = $('#getVaraint-' + pro_id + ' option:selected').text();
            if (text != 0) {
              $('.prop-' + pro_id).val(text);
              var price = $('#getVaraint-' + pro_id + ' option:selected').attr('data-price');
              add_price += parseFloat(price / 100);
            } else {
              $('.prop-' + pro_id).val('');
            }
          });
          setTimeout(function () {
            thisPrice = (thisPrice + add_price).toFixed(2).replace('.', ',');
            $('.totalPrice').text('Totale : ' + thisPrice + ' €');
          }, 500);
        }
      });
    }, 500);
  });

  $('body').on('click', '.multipleProduct', function (e) {
    e.preventDefault();
    var available_ids = [], available_qty = [], pName = [], pValue = [];
    $('.additionUpsell').each(function () {
      var pro_id = $(this).attr('data-id');
      var text = $('#getVaraint-' + pro_id + ' option:selected').text();
      if (text != 0) {
        var variant_id = parseInt($('.upsell_' + pro_id).val());
        var qty = parseInt($('#getVaraint-' + pro_id + ' option:selected').val());
        available_ids.push(variant_id);
        available_qty.push(qty);
        pName.push($('.prop-' + pro_id).attr('ptitle'));
        pValue.push(parseInt($('.prop-' + pro_id).val()));
      }
    });
    if (available_ids.length == 0) {
      $('#AddToCart').click();
    } else {
      for (var i = 0; i < available_ids.length; i++) {
        (function (i) {
          setTimeout(function () {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: 'quantity=' + available_qty[i] + '&id=' + available_ids[i],
              dataType: 'json',
              success: function (line_item) {
                if (i + 1 == available_ids.length) {
                  $('.Spin-pro').addClass('hide');
                  $('.Text-pro').show();
                  $('#AddToCart').click();
                }
              }
            });
          }, 1000 * i);
        })(i);
      }
    }
  });
}